// Example:
//
// warningAutoplayPrevent(myAudio.play())
//

export function warningAutoplayPrevented(playPromise: Promise<void>): boolean {
  if (playPromise !== undefined) {
    playPromise
      .then(() => {
        // Start whatever you need to do only after playback
      })
      .catch((error) => {
        if (error.name === 'NotAllowedError') {
          console.warn("Autoplay was prevented. Site settings => Sound: 'Allow'")
          return true
        } else {
          // Handle a load or playback error
        }
      })
  }
  return false
}
